import { render, staticRenderFns } from "./FigmaIcon.vue?vue&type=template&id=5e850601&scoped=true"
import script from "./FigmaIcon.vue?vue&type=script&lang=js"
export * from "./FigmaIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e850601",
  null
  
)

export default component.exports